import { AttributeInput } from "services/interface";
import styled from "@emotion/styled";
import {  FormInstance, Row } from "antd";
import { FC } from "react";
import ProductAtributteCard from "./ProductAttributeCard";
import ProductCategoryCard from "./ProductCategoryCard";
import ProductDescriptionForm from "./ProductDescriptionForm";
import ProductImageCard from "./ProductImageCard";
import ProductNameForm from "./ProductNameForm";
import ProductVariationCard from "./ProductVariationCard";
import ProductRecommendForm from "./ProductRecommendForm";
import ProductOpenSaleForm from "./ProductOpenSale";
import ProductRetailTypeCard from "./ProductRetailTypeCard";

interface MainCreateProductProps {
  form: FormInstance;
  onFinish: (values: any) => void;
  attribute: AttributeInput[];
  setAttribute: (attribute: AttributeInput[]) => void;
  setVariants: (variants: VariantsInput) => void;
  variants: VariantsInput;
  prices: PricesInput;
  setPrices: (prices: PricesInput) => void;
  setCheckIsActive: (checkIsActive: boolean) => void;
  checkIsActive: boolean;
  setContent: (content: string) => void;
  content: string;
  is_guid: boolean;
  setIsGuid: (is_guid: boolean) => void;
  is_inventory: boolean;
}

const MainCreateProduct: FC<MainCreateProductProps> = ({
  attribute,
  setAttribute,
  setVariants,
  variants,
  prices,
  setPrices,
  checkIsActive,
  setCheckIsActive,
  setContent,
  content,
  is_guid,
  setIsGuid,
  is_inventory,
}) => {
  return (
    <FormWrapper>
      <ProductImageCard is_active={checkIsActive}  setCheckIsActive={setCheckIsActive}  is_guid={is_guid} setIsGuid={setIsGuid} />
      <FormItemWrapper>
        {/* <ProductOpenSaleForm setCheckIsActive={setCheckIsActive} /> */}
        <ProductNameForm is_active={checkIsActive} />
        <ProductRecommendForm />
        <ProductDescriptionForm content={content} setContent={setContent} is_active={checkIsActive} />
      </FormItemWrapper>
      {/* <ProductImageDesCard /> */}
      <FormItemWrapper>
        <Row gutter={[16, 16]} style={{ backgroundColor: "#EFEFEFEF" }}>
          <ProductCategoryCard />
          <ProductRetailTypeCard />
          <ProductVariationCard
            is_guid={is_guid}
            setVariants={setVariants}
            variants={variants}
            prices={prices}
            setPrices={setPrices}
            is_inventory={is_inventory}
          />
          <ProductAtributteCard
            attribute={attribute}
            setAttribute={setAttribute}
          />
        </Row>
      </FormItemWrapper>
    </FormWrapper>
  );
};

export default MainCreateProduct;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #efefefef;
`;

const FormItemWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 10px 0px 10px 0px;
  border-radius: 10px;
`;
